import React, { useEffect, useState } from "react";
import "./Overview.css";
import CustomSelect from "../profileEngine/CustomSelect";
import { useNavigate } from "react-router-dom";

interface OverviewProps {
  users: any[];
  templates: { id?: string; name: string }[];
  submissions: any[];
}

const Overview: React.FC<OverviewProps> = ({
  users,
  templates,
  submissions: _submissions,
}) => {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState<Record<string, string>>({});
  const [statuses, setStatuses] = useState<Record<string, string>>({});

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/user-profile-assignments`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        const map: Record<string, string> = {};
        data.forEach((a: any) => {
          map[a.userId] = a.profileTemplateId;
        });
        setAssignments(map);
      })
      .catch((err) =>
        console.error("Failed to load user profile assignments", err),
      );
  }, [users]);

  return (
    <div className="overview-root profiles-overview">
      <div className="template-list">
        <div className="template-card">
          <div className="overview-header">
            <div>Name</div>
            <div>Email</div>
            <div>Phone</div>
            <div>Status</div>
            <div>Template</div>
            <div>Last login</div>
            <div>Actions</div>
          </div>

          {[...users]

            .sort((a, b) => {
              const getLast = (name = "") =>
                name.trim().split(" ").slice(-1)[0].toLowerCase();

              return getLast(a.name || a.email).localeCompare(
                getLast(b.name || b.email),
              );
            })
            .map((u, i) => (
              <div key={i} className="overview-row">
                {/* The column trims anything too long for it, so the full
                    value is carried on the cell for hover. */}
                <div title={u.name || u.email}>{u.name || u.email}</div>
                <div title={u.email}>{u.email}</div>
                <div>{u.phone || "—"}</div>

                {/* STATUS SELECT — defaults to Active for everyone until the
                    status is actually wired up / persisted. */}
                <CustomSelect
                  value={statuses[u.user_id] || "Active"}
                  placeholder="Select"
                  options={[
                    { value: "Active", label: "Active" },
                    { value: "Inactive", label: "Inactive" },
                  ]}
                  onChange={(value: string) =>
                    setStatuses((prev) => ({
                      ...prev,
                      [u.user_id]: value,
                    }))
                  }
                />

                {/* TEMPLATE SELECT */}
                <CustomSelect
                  value={assignments[u.user_id] || ""}
                  placeholder="Select"
                  options={templates.map((t) => ({
                    value: t.id || "",
                    label: t.name,
                  }))}
                  onChange={async (profileTemplateId: string) => {
                    await fetch(
                      `${process.env.REACT_APP_BACKEND_URL}/approved_users/${u.user_id}/template`,
                      {
                        method: "POST",
                        credentials: "include",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ profileTemplateId }),
                      },
                    );

                    setAssignments((prev) => ({
                      ...prev,
                      [u.user_id]: profileTemplateId,
                    }));
                  }}
                />

                <div>
                  {u.last_login ? new Date(u.last_login).toLocaleString() : "—"}
                </div>

                <button
                  className="btn-icon smrtdocs-btn-view"
                  title="View"
                  disabled={!assignments[u.user_id]}
                  onClick={() => {
                    const templateId = assignments[u.user_id];
                    if (!templateId) return;
                    navigate(`/profiles/view/${u.user_id}/${templateId}`);
                  }}
                >
                  👁
                </button>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Overview;
